import Iconify from "minimals-template/components/Iconify"

export function NeutralSortIcon(props) {
    return <Iconify {...props} icon="mdi:unfold-more-horizontal" />
}
